export enum EPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right'
}

export type Positions = EPosition.TOP | EPosition.BOTTOM | EPosition.LEFT | EPosition.RIGHT
